import type { TFunction } from "i18next";
import { NS } from "../../../U3125";
import {
  u3125AvailableCreditAlertDisplayLines,
  type U3125AvailableCreditAlert,
} from "../../../U3125Service";

interface U3125AvailableCreditAlertBannerProps {
  alert: U3125AvailableCreditAlert;
  t: TFunction;
}

function U3125AvailableCreditAlertBanner({ alert, t }: U3125AvailableCreditAlertBannerProps) {
  const lines = u3125AvailableCreditAlertDisplayLines(alert, t);
  if (lines.length === 0) return null;

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3.5 text-sm text-amber-900">
      <p className="font-medium">{t("msgAvailableCreditAlertTitle", { ns: NS })}</p>
      <ul className="mt-2 list-disc space-y-1 pl-5">
        {lines.map((line, index) => (
          <li key={index}>{line.text}</li>
        ))}
      </ul>
    </div>
  );
}

export default U3125AvailableCreditAlertBanner;
